import React from 'react'

const Manual_menu_items = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl:text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
          MENÚ - Ítems
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          La guía explica cómo crear o editar ítems de servicio en el sistema POS, asegurando precios y categorización precisos. Ayuda a optimizar operaciones, cumplir normativas fiscales y mejorar el servicio al cliente.
        </p>
        <iframe
          src="https://scribehow.com/embed/MENU__Items__nQZs55A5QriJwzH2a7gvYg?as=scrollable"
          className="scribe-iframe-general-17"
          width="100%"
          height="4600"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_menu_items